var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 496,
    height: 494,
    viewBox: "0 0 496 494",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M208.442 244.624C187.158 221.31 154.154 212.691 124.189 222.623L114 226L250.5 409C250.5 409 350.135 295.057 385.634 255.057C421.133 215.057 472.133 209.558 494.633 262.057C470.633 151.055 367.633 147.557 306.133 219.058C252.296 281.65 247.887 287.148 247.624 287.546L208.442 244.624Z",
    fill: "#E3E8EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.656 72.3449C380.021 30.71 324.882 5.31788 266.179 0.74604C207.476 -3.8258 149.071 12.7234 101.492 47.4103C53.9125 82.0972 20.2899 132.64 6.68459 189.927C-6.9207 247.215 0.38644 307.478 27.2888 359.853C54.1911 412.229 98.9189 453.272 153.409 475.582C207.899 497.893 268.567 500.004 324.476 481.535C380.386 463.066 427.858 425.232 458.336 374.853C488.814 324.474 506.5 255.5 487.5 208.5L386.5 218C434 216.5 409.015 298.908 388.595 332.662C368.175 366.415 336.368 391.764 298.909 404.139C261.45 416.513 220.803 415.098 184.294 400.15C147.786 385.202 117.818 357.704 99.7936 322.612C81.769 287.52 76.8732 247.144 85.9888 208.761C95.1043 170.379 117.632 136.515 149.509 113.275C181.387 90.0348 220.519 78.9468 259.85 82.01C279.028 83.5035 297.638 88.3137 314.908 96.0849C345.127 109.683 383.014 110.986 406.446 87.5548L421.656 72.3449Z",
    fill: "url(#paint0_linear_139_517)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M495.178 261C497.181 230.215 448.114 203.095 411.041 233.742C405.196 222.825 399.155 217.876 386 218.105C444.596 158.054 503.692 195.903 495.178 261Z",
    fill: "#CA701F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M227.02 229.976C197.376 197.503 146.675 195.405 114 224.826L250.633 376.057C250.633 376.057 350.134 260.057 385.634 220.057C421.133 180.058 470.5 174.5 493 227C469 115.998 367.633 112.558 306.133 184.059C252.296 246.651 247.887 252.148 247.624 252.547L227.02 229.976Z",
    fill: "url(#paint1_linear_139_517)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_139_517",
    x1: 101.5,
    y1: 48,
    x2: 370,
    y2: 457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F26D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA931F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_139_517",
    x1: 480.5,
    y1: 190.814,
    x2: 114.01,
    y2: 224.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#185B2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60B70C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.df228efc3686b0e5cc090a5bdf087f8d.svg";
export { ForwardRef as ReactComponent };